import { UploadType } from "../static/enums/UploadType";
import { rootStore } from "../mobx";
import { FilesApi } from "../api/questions/FilesApi";
import { ImportQuestionsData } from "../mobx/stores/questions/models";
import { getFileExt } from "../helpers/files";

interface UploadData {
	type: UploadType;
	files: FileList;
}

class UploadFilesService {
	private static async uploadQuestionsFiles(
		files: FileList,
		onUploadProgress: (progressEvent: ProgressEvent) => void
	): Promise<ImportQuestionsData> {
		const uploadFiles = [];
		for (let i = 0; i < files.length; i++) {
			const formData = new FormData();
			formData.append("file", files[i]);
			uploadFiles.push(FilesApi.uploadFiles(formData, onUploadProgress));
		}
		const uploadedFiles = (await Promise.all(uploadFiles)) as unknown as { filename: string }[];
		return {
			imagesFilename: uploadedFiles.find((file) => getFileExt(file.filename) === "zip")!.filename,
			dataFilename: uploadedFiles.find((file) => getFileExt(file.filename).includes("xls"))!.filename,
		};
	}

	private static async uploadFile(
		files: FileList,
		onUploadProgress: (progressEvent: ProgressEvent) => void
	): Promise<{ filename: string }> {
		const formData = new FormData();
		formData.append("file", files[0]);
		const { filename } = (await FilesApi.uploadFiles(formData, onUploadProgress)) as unknown as {
			filename: string;
			download: string;
			mime: string;
			modified: string;
			size: number;
		};
		return { filename };
	}

	async importImage(
		files: FileList,
		onUploadProgress: (progressEvent: ProgressEvent) => void
	): Promise<{ filename: string; download: string }> {
		const formData = new FormData();
		formData.append("file", files[0]);
		const { filename, download } = (await FilesApi.uploadFiles(formData, onUploadProgress)) as unknown as {
			filename: string;
			download: string;
			mime: string;
			modified: string;
			size: number;
		};

		return { filename, download };
	}

	async importFiles({ files, type }: UploadData, onUploadProgress: (progressEvent: ProgressEvent) => void) {
		let response;

		switch (type) {
			case UploadType.skills:
				response = await UploadFilesService.uploadFile(files, onUploadProgress);
				await rootStore.skillsStore.importSkills(response);
				break;
			case UploadType.topics:
				response = await UploadFilesService.uploadFile(files, onUploadProgress);
				await rootStore.topicsStore.importTopics(response);
				break;
			case UploadType.questions:
				response = await UploadFilesService.uploadQuestionsFiles(files, onUploadProgress);
				await rootStore.questionsStore.importQuestions(response);
				break;
			default:
				throw new Error("Wrong type of upload data");
		}
	}
}

export const uploadFilesService = new UploadFilesService();
